const progressData = [
	{
		id: 'intro',
		text: {
			da: 'Introduktion',
			en: 'Introduction'
		}
	},
	{
		id: 'groups',
		text: {
			da: 'Grupper',
			en: 'Groups'
		}
	},
	{
		id: 'results',
		text: {
			da: 'Opsamling',
			en: 'Summary'
		}
	},
];



export {
	progressData
};